import { createAction, handleActions } from 'redux-actions';

const setSearchTerm = createAction('SCREENS/PROFIT_AND_LOSS/SET_SEARCH_TERM');
const clearSearchTerm = createAction('SCREENS/PROFIT_AND_LOSS/CLEAR_SEARCH_TERM');

const defaultState = '';

const reducer = handleActions(
  {
    [setSearchTerm]: (state, action) => action.payload,
    [clearSearchTerm]: () => ''
  },
  defaultState
);

export { setSearchTerm, clearSearchTerm, reducer };
